<template>
  <q-btn
    flat
    class="relative-position">
    <q-icon class="fa fa-2x fa-th-large"/>
  </q-btn>
</template>
<script>
import { QBtn, QIcon } from 'quasar'
export default {
  components: { QBtn, QIcon }
}
</script>
<style scoped>
</style>
